import { render, staticRenderFns } from "./add.vue?vue&type=template&id=43995ea3&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43995ea3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43995ea3')) {
      api.createRecord('43995ea3', component.options)
    } else {
      api.reload('43995ea3', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=43995ea3&scoped=true&", function () {
      api.rerender('43995ea3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberShopFit/add.vue"
export default component.exports